import { getAuthHeaders } from '../../statistics/api/auth-headers';

/**
 * Цифры со скриншота «Статистика публикации».
 *
 * По части публикаций метрик нет ни у кого, кроме владельца аккаунта: паблик
 * не подключён к InstaFarm. Тогда человек приносит скриншот из приложения, а
 * цифры с него снимает модель на бэкенде — вводить с клавиатуры десять чисел
 * на каждую публикацию и есть та работа, ради которой отчёт автоматизировали.
 */

export type RecognizedScreen = {
  kind: 'reel' | 'post';
  username: string | null;
  views: number | null;
  reach: number | null;
  likes: number | null;
  comments: number | null;
  reposts: number | null;
  shares: number | null;
  saved: number | null;
  profileVisits: number | null;
  follows: number | null;
  avgWatchSeconds: number | null;
};

/** image — data-URL уменьшенного скриншота (см. lib/downscale). */
export async function recognizeInsightsScreen(image: string): Promise<RecognizedScreen> {
  const headers = await getAuthHeaders();
  const res = await fetch('/api/presentation/insights-screen', {
    method: 'POST',
    headers,
    body: JSON.stringify({ image }),
  });
  if (!res.ok) {
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(body.error || `Не удалось прочитать скриншот: ${res.status}`);
  }
  return (await res.json()) as RecognizedScreen;
}
